import styled from 'styled-components';
import {RiCloseCircleLine} from 'react-icons/ri';

export const ContainerInput = styled.div`
  display: inline-flex;
  align-items: center;
`;
export const CloseIcon = styled(RiCloseCircleLine)`
  padding-right: 5px;
  padding-left: 5px;
  margin-left: auto;
  color: #acb1c0;
  cursor: pointer;
  font-size: 21px;
`;
export const InputDate = styled.div`
  box-sizing: border-box;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #ffffff;
  &:first-child {
    margin: 0px 16px 0px 0px;
  }
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: fit-content;
  input {
    display: inline-block;
    text-align: start;
    width: 75px;
    margin: 0px 5px 0px 5px;
    appearance: textfield;
    -webkit-rtl-ordering: logical;
    cursor: pointer;
    color: rgba(62, 70, 78, 1);
    font-family: 'Proxima Nova';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 31px;
    text-align: center;
    border: 0px !important;
  }
  input:focus {
    outline: 0px !important;
  }
  div .react-datepicker__day--selected {
    background-color: var(--PrimaryBlue);
  }
  .react-datepicker {
    border: 0px !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);
    .react-datepicker__header {
      border-bottom: 0px;
      background: #e8e9ed;
    }
  }
`;
export const ContainerText = styled.div`
  display: flex;
  border-radius: 8px;
  flex-direction: row;
  width: fit-content;
  box-sizing: border-box;
  margin: 0px 16px 0px 0px;
  justify-content: flex-end;
`;
export const MiddleText = styled.span`
  color: #5D6E81;
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  line-height: 14.3px;
  letter-spacing: 0.1px;
  font-family: "Proxima Nova";
`;